<!-- <div ng-class="{'is-required': vm.required, 'is-disabled': vm.disabled}"> -->
<div [class.is-required]="required"
  [class.is-disabled]="disabled"
  [class.is-invalid]="!validation.isHidden">
  @if (label) {
    <label class="label"
    >{{label}}</label>
  }

  <ng-content></ng-content>

  <validation [attr.cy-input-validation]="label"
    [messages]="messages"
    [canShow]="canShowValidate"
  #validation></validation>
</div>
